import { useEffect } from "react";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { CountyRuleTestRequest, CountyRule } from "../../../../models";

import { StringDetailedResponse } from "../../../../models/swagger/generated-submission-service";
import { CountyRulesService } from "../../../../services/ClientService";

export type CountyRuleTestModalProps = {
    show: boolean;
    attorneyId?: string;
    clientCountyname?: string;
    ruleId?: string;
    clientDivisionName?: string;
    data?: CountyRule;
    onSubmit: () => void;
    onClose: () => void;
};

export default function CountyRuleTestModal({
    show,
    attorneyId,
    clientCountyname,
    clientDivisionName,
    onSubmit,
    onClose,
}: CountyRuleTestModalProps) {
    const [rule, setRule] = useState({
        attorneyID: attorneyId,
        clientCountyname: clientCountyname,
        clientDivisionName: clientDivisionName,
    } as CountyRuleTestRequest);

    const [data, setData] = useState("");

    useEffect(() => {
        setRule({
            attorneyID: attorneyId,
            clientCountyName: clientCountyname ?? "",
            clientDivisionName: clientDivisionName ?? "",
        });
    }, [show, attorneyId, clientCountyname, clientDivisionName]);

    const submitRule = () => {
        CountyRulesService.getRule({
            body: {
                ...rule,
            },
        }).then(
            (resp) => {
                // onSubmit();
                setData(JSON.stringify(resp.data));
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const closeWindow = () => {
        setData("");
        onClose();
    };

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    County Rule Test
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row form-group m-2">
                    <div className="col-sm-6">
                        <label>Attorney ID</label>
                        <input
                            className="form-control"
                            id="divisionRuleAttorneyID"
                            type="text"
                            defaultValue={rule.attorneyID}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    attorneyID: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                    <div className="col-sm-6">
                        <label>Client County</label>
                        <input
                            className="form-control"
                            type="text"
                            defaultValue={rule.clientCountyName}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    clientCountyName: event.currentTarget.value,
                                })
                            }
                        />
                    </div>

                    <div className="col-sm-6">
                        <label>Client Division</label>
                        <input
                            className="form-control"
                            id="divisionRuleCsvDivision"
                            type="text"
                            defaultValue={rule.clientDivisionName}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    clientDivisionName:
                                        event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>
                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>Result:</label>
                        <label>{data}</label>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-danger" onClick={closeWindow}>
                    Cancel
                </Button>
                <Button onClick={submitRule}>Submit</Button>
            </Modal.Footer>
        </Modal>
    );
}
